import { render, staticRenderFns } from "./budget-ledger.vue?vue&type=template&id=062ec9ca&scoped=true"
import script from "./budget-ledger.vue?vue&type=script&lang=js"
export * from "./budget-ledger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ec9ca",
  null
  
)

export default component.exports